
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.485 10H1.517h16.968zM10 18.486L9.996 1.518 10 18.486z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18.485 10H1.517M10 18.487L9.997 1.518","stroke":"#333","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    